<template>
    
    <div class="HeaderPage">
            <div class="titles">
            <p class="title">{{ title }}</p>
            <p class="titleTwo">{{ titleTwo }}</p>
            <button class="callUs" @click="showPhoneModal = true">
            <img src="../assets/phoneIcon.png" alt="Phone" class="phoneIcon" />
            <span class="callUsToday"> Call Us Today!</span>
            </button>
        
        </div>

        <div class="break"></div>
    </div>

  <PhoneModal v-if="showPhoneModal" @close="showPhoneModal = false" />


</template>

<script>
import PhoneModal from '@/components/PhoneModal.vue';
export default {
    name: 'PageHeader',
    components: { PhoneModal },
    data() {
        return { showPhoneModal: false }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        titleTwo: {
            type: String,
            default: ''
        },
    }
}
</script>

<style scoped>

.background{
    display: flex;
    flex-direction: row;

}
.titles {
    background-color: #2c3e50;
    border-bottom: #212121 1px solid;
    position: fixed;
    top: 0;
    height: 80px;
    width: 100%;
    z-index: 100;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
}
.title {
    color: #f1c40f;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    width: 30%;
}
.titleTwo {
    color: #f1c40f;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    width: 30%;
}
@media (max-width: 600px) {
    .titles {
        height: 64px;
        padding: 6px 8px;
    }
    .title,
    .titleTwo {
        font-size: 13px;
        margin: 0 4px;
    }
}

.break{
 width: 100%;
 border-bottom: #212121 .25em solid;
}
.callUs {
    background: linear-gradient(135deg, #8d0808 0%, #bf1414 55%, #e04a2d 100%);
    color: white;
    height: 40px;
    position: fixed;
    right: 0;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 800;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    cursor: pointer;
    transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
    display: flex;
    align-items: center;
    margin-right: 5px;
    width: 35%;
    justify-content: space-evenly;
    overflow: hidden;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.34), 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
}

.callUs::before {
    content: '';
    position: absolute;
    top: 0;
    left: -130%;
    width: 50%;
    height: 100%;
    transform: skewX(-22deg);
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 100%);
    transition: left 0.45s ease;
}

.callUs a {
    color: white;
    text-decoration: none;
    font-weight: bolder;
}

@media (max-width: 550px) {
    .callUs {
        padding: 2px 2px;
        font-size: 10px;
    }
}
.phoneIcon {
    width: 30px;
    height: 30px;
}

@media (hover: hover) and (pointer: fine) {
    .callUs:hover {
        transform: translateY(-3px) scale(1.02);
        box-shadow: 0 14px 30px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(255, 255, 255, 0.14) inset;
        filter: saturate(1.08) brightness(1.05);
    }

    .callUs:hover::before {
        left: 130%;
    }
}

.callUs:active {
    transform: translateY(1px) scale(0.995);
    filter: brightness(0.98);
}

.callUs:active::before {
    left: 130%;
}

.callUs:focus-visible {
    outline: 3px solid #f1c40f;
    outline-offset: 2px;
}

</style>

